import { render, staticRenderFns } from "./SelectMultipleClients.vue?vue&type=template&id=855489f0&"
import script from "./SelectMultipleClients.vue?vue&type=script&lang=ts&"
export * from "./SelectMultipleClients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports